<app-container>

  <app-content-block cssStyle="form">

    <ng-container *ngIf="bankAccount$ | async as bankAccount">

      <form [formGroup]="form">

        <h1>Edit bank account</h1>

        <app-form [form]="form"></app-form>

        <div class="buttons">
          <button mat-flat-button color="primary" (click)="submit(bankAccount)">Save</button>
          <button mat-stroked-button [routerLink]="['/bank-accounts', bankAccount.id]">Cancel</button>
        </div>

      </form>

    </ng-container>

  </app-content-block>

</app-container>